import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import {
  listado_datos_personales,
  update_datosPersonales,
  update_paso,
} from "../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import ModalError from "./ModalError";

const ActualizacionDeDatos = () => {
  const { obtenerDatosEstudiante } = useMatricula();
  const [msjCelular, setMsjCelular] = useState({});
  const [msjEmail, setMsjEmail] = useState({});
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  let {
    listadoDatosPersonales,
    setPasoProcesoM,
    celular,
    setCelular,
    correo,
    setCorreo,
    setLoading,
    setListadoDatosPersonales,
    errorServices, setErrorServices,
    setErrorCursoServices
  } = useProcesoMatricula();

  

  const {
    ape_materno,
    ape_paterno,
    ccorreo,
    cpersona,
    ncelular,
    nombre,
    nro_documento,
    tipo_documento,
  } = listadoDatosPersonales;


  

  useEffect(() => {
    setCorreo(ccorreo);
    setCelular(ncelular);
  }, [listadoDatosPersonales]);

  useEffect(() => {
    setCorreo(ccorreo);
    setCelular(ncelular);
  }, [ncelular, ccorreo]);

  useEffect(() => {
    const { cinstitucion } = obtenerDatosEstudiante;
    if (cinstitucion) {
      try {
        
        listado_datos_personales(
          obtenerDatosEstudiante,
          setListadoDatosPersonales,
          setLoading
        );
         
      } catch (error) {
        
      } finally {
      }
    }
  }, [obtenerDatosEstudiante]);
 

  const soloLetras = (e) => {
    let regex = new RegExp("^[0-9]+$");
    let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (!regex.test(key) || e.target.value.length === 9) {
      e.preventDefault();
      return false;
    }
  };

  const validarBtnActualizacion = async (e) => {
    e.preventDefault();
    
    let celulars = /[0-9\+]{9}$/;
    
    const emailRegexp = new RegExp(
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z]{2,4})+$/
    );
    let refCelular = document.querySelector(".edCelular");

    if (!celulars.test(celular)) {
     
      setMsjCelular({ msj: `${lbl_validacion_msj_celular}` });
      if (refCelular) {
        refCelular.classList.add("ed-is-invalid");
      }
     
    } else {
      if (refCelular) {
        if (refCelular.classList.contains("ed-is-invalid")) {
          refCelular.classList.remove("ed-is-invalid");
        }
      }

      setMsjCelular({});
    }

    let refCorreo = document.querySelector(".edCorreo");

    if (!emailRegexp.test(correo)) {
     
      setMsjEmail({ msj: `${lbl_validacion_msj_correo}.` });
      if (refCorreo) {
        refCorreo.classList.add("ed-is-invalid");
      }
    } else {
      setMsjEmail({});
      if (refCorreo) {
        if (refCorreo.classList.contains("ed-is-invalid")) {
          refCorreo.classList.remove("ed-is-invalid");
        }
      }
    }

    if (celulars.test(celular) && emailRegexp.test(correo)) {
    

      try {
        setLoading(true);
        const updateDatosPersonales = await update_datosPersonales(listadoDatosPersonales, {
          celular,
          correo: String(correo).toUpperCase(),
        });
        if (updateDatosPersonales.StatusCode==200 && updateDatosPersonales.Code==1  ) {
           let updatePasos = await update_paso(obtenerDatosEstudiante, 1,1);
           if (updatePasos.StatusCode==200 && updatePasos.Code==1) {
            let convertirPasoCompletadoMayoCero = Number(updatePasos.Data.paso_siguiente)
            let convertirPasoCompletado = convertirPasoCompletadoMayoCero > 0 ?convertirPasoCompletadoMayoCero-1: convertirPasoCompletadoMayoCero
            setPasoProcesoM(convertirPasoCompletado);

            
           } else{
            throw updatePasos.Message
           }
         
        } else{
          throw updateDatosPersonales.Message
        }
       
      } catch (error) {
        setLoading(false);
        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
            modalErrorr.click();
            
            setErrorCursoServices(error)
        }
      } finally {
        setLoading(false);
        
      }
    }
  };

  useEffect(() => {
    
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        actualizacion_datos: obtenerLabelEtiqueta(
          "lbl_global_actualizacion_datos",
          listadoEtiquetas
        ),
        datos_tipo_documento: obtenerLabelEtiqueta(
          "lbl_update_datos_tipo_documento",
          listadoEtiquetas
        ),
        datos_numero_documento: obtenerLabelEtiqueta(
          "lbl_update_datos_numero_documento",
          listadoEtiquetas
        ),
        datos_nombres: obtenerLabelEtiqueta(
          "lbl_update_datos_nombres",
          listadoEtiquetas
        ),
        datos_primer_apellido: obtenerLabelEtiqueta(
          "lbl_update_datos_primer_apellido",
          listadoEtiquetas
        ),
        datos_segundo_apellido: obtenerLabelEtiqueta(
          "lbl_update_datos_segundo_apellido",
          listadoEtiquetas
        ),
        datos_celular: obtenerLabelEtiqueta(
          "lbl_update_datos_celular",
          listadoEtiquetas
        ),
        datos_correo_personal: obtenerLabelEtiqueta(
          "lbl_update_datos_correo_personal",
          listadoEtiquetas
        ),
        msj_actualizacion: obtenerLabelEtiqueta(
          "lbl_update_datos_msj_actualizacion",
          listadoEtiquetas
        ),
        datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
        lbl_validacion_msj_celular: obtenerLabelEtiqueta(
          "lbl_validacion_msj_celular",
          listadoEtiquetas
        ),
        lbl_validacion_msj_correo: obtenerLabelEtiqueta(
          "lbl_validacion_msj_correo",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    actualizacion_datos,
    datos_tipo_documento,
    datos_numero_documento,
    datos_nombres,
    datos_primer_apellido,
    datos_segundo_apellido,
    datos_celular,
    datos_correo_personal,
    msj_actualizacion,
    datos_continuar,
    lbl_validacion_msj_celular,
    lbl_validacion_msj_correo,
  } = etiquetas;

  let { msj: msjCel } = msjCelular;
  let { msj } = msjEmail;

  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <form onSubmit={validarBtnActualizacion}>
              <div className="form-body animate-fade animate__animated animate__fadeIn">
                <div className="matricula-title">
                  <h5 className="text-uppercase">{actualizacion_datos}</h5>
                  <div className="separator"></div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="control-label">
                        {datos_tipo_documento}
                      </label>
                     

                      <input
                        type="text"
                        id="lastName"
                        disabled
                        className="form-control form-control-sm form-control-danger"
                        placeholder={tipo_documento ? tipo_documento : ""}
                        onChange={(e) => {}}
                        value={tipo_documento ? tipo_documento : ""}
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="control-label">
                        {datos_numero_documento}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        id="lastName"
                        disabled
                        className="form-control form-control-sm form-control-danger"
                        placeholder={nro_documento ? nro_documento : ""}
                        onChange={(e) => {}}
                        value={nro_documento ? nro_documento : ""}
                      />
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="control-label">{datos_nombres}</label>
                      <input
                        autoComplete="off"
                        type="text"
                        id="firstName"
                        disabled
                        className="form-control form-control-sm"
                        placeholder={nombre ? nombre : ""}
                        value={nombre ? nombre : ""}
                        onChange={(e) => {}}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="control-label">
                        {datos_primer_apellido}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        id="lastName"
                        disabled
                        className="form-control form-control-sm form-control-danger"
                        placeholder={ape_paterno ? ape_paterno : ""}
                        value={ape_paterno ? ape_paterno : ""}
                        onChange={(e) => {}}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="control-label">
                        {datos_segundo_apellido}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        id="lastName"
                        disabled
                        className="form-control form-control-sm form-control-danger"
                        placeholder={ape_materno ? ape_materno : ""}
                        value={ape_materno ? ape_materno : ""}
                        onChange={(e) => {}}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="control-label">{datos_celular}</label>
                      <input
                        type="text"
                        id="firstName miInput"
                        className="form-control form-control-sm edCelular"
                        value={celular?celular:""}
                        onChange={(e) => {
                          setCelular(e.target.value);
                        }}
                        onKeyPress={(e) => soloLetras(e)}
                        onPaste={(e) => {
                          e.preventDefault();
                        }}
                        autoComplete="off"
                        required
                      />
                      {msjCel && (
                        <label className="msjActualizacionDatos">
                          {msjCel}
                        </label>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="control-label">
                        {datos_correo_personal}
                      </label>
                      <input
                        autoComplete="off"
                        required
                        type="email"
                        id="lastName"
                        className="form-control form-control-sm form-control-danger edCorreo text-uppercase"
                        value={correo?correo:""}
                        onChange={(e) => {
                          setCorreo(e.target.value);
                        }}
                      />
                      {msj && (
                        <label className="msjActualizacionDatos">{msj}</label>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <small className="form-control-feedback">
                    <p
                      style={{
                        lineHeight: "1.5",
                        fontSize: "13px",
                        marginTop: "1rem",
                      }}
                    >
                      *{msj_actualizacion}.
                    </p>
                  </small>
                </div>
              </div>
              <button
                type="submit"
                className="btn waves-effect waves-light btn-primary next"
              >
                {datos_continuar}
              </button>
            </form>
          </fieldset>
        </div>
      </div>
      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#error"
        id="modalErr"
      ></button>
    
    </div>
  );
};

export default ActualizacionDeDatos;
